import ActionsModel from '@/models/actions/ActionsModel';
import { ModelTypes } from '@/typings/types/types';
import { SdkActionModel } from '../models/action';

export class SdkActionEvent {
  #action: SdkActionModel;
  #promises: Promise<void>[] = [];
  #defaultPrevented = false;

  constructor(action: ActionsModel, model: ModelTypes) {
    this.#action = new SdkActionModel(action, model);
  }

  public suspense(fn: () => Promise<void>) {
    this.#promises.push(fn());
  }

  async waitForPromises() {
    await Promise.all(this.#promises);
  }

  public preventDefault() {
    this.#defaultPrevented = true;
  }

  public get defaultPrevented() {
    return this.#defaultPrevented;
  }

  public get origin() {
    return this.#action.origin;
  }

  public get action(): SdkActionModel {
    return this.#action;
  }
}
